import React, { Component } from 'react';
import Footer from '../footer/newfooter';
import Header from '../header/newheader'
import Axios from 'axios';
import { BASE } from "../api/api";
import './reference.css'


class reference extends Component {
    constructor(props) {
        super(props);
        this.state = {
            nid:props.match.params.id
        };

    }
    topFunction() {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }
    componentWillMount() {
        
        this.topFunction()
        if(this.props.location.state===undefined)
        { 
            Axios.get(BASE+'/jsonapi/node/references?filter[drupal_internal__nid]='+this.state.nid)

            .then((data) => {  
                this.setState({
                    sub_data:data.data.data[0].attributes
                })

            })
            
        }
        else
        {
            this.setState({
                sub_data:this.props.location.state.dat_arr
            })
          
            

        }
        
       

    }
    render() {
        return (
            <div className='institutions eventpage sub_work'>
                <Header/>
                <body className="wiki" >


                    <div className="page-title">
                        <div className="title-wrapper">
                            <div className="container">

                            </div>
                        </div>
                    </div>

                    <div className="main-content">
                        <div className="container">
                            <div className="row">
                                <div className="node-wiki node">


                                    <div className="group-middle">
                                        <div className="field-name-title">
                                            <div className='ref_title'>{this.state.sub_data ? this.state.sub_data.title : ''}</div>
                                            <div className="field-name-metadata-books">
                                                <div className="field-item even">
                                                    <div className="view-wiki">
                                                       

                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="field field-name-body field-type-text-with-summary field-label-hidden">
                                            <div className="field-items">
                                            
                                            </div>
                                        </div>
                                       

                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>



                </body>


                <div><Footer /></div>
            </div>


        )
    }
}

export default reference;